import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderTypes(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/ordertypes/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    orderTypes: data,
    mutate: mutate,
  };
}

export default useOrderTypes;
